<mat-dialog-content class="mat-typography">
  <p [innerHTML]="data.message" class="p-5 border-bottom"></p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="btn btn-outline-secondary" (click)="onNoClick()">{{ data.cancelButton }}</button>
  <button [mat-dialog-close]="true" cdkFocusInitial class="btn btn-primary ml-2">{{data.confirmButton}}</button>
</mat-dialog-actions>